// OwnerBottomNav.tsx — شريط تنقّل سفليّ للجوال (Owner_Portal_UX_Redesign_Plan_2026-07-12.md §3.2).
// يظهر <sm فقط. الوجهات من ownerNav.ts (مصدر مشترك مع OwnerTopBar — لا تكرار).
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { hasPagePermission } from '../../lib/accessControl';
import { readJsonStorage } from '../../lib/storage';
import type { Permission } from '../../lib/accessControl';
import { cn } from '../../lib/utils';
import { OWNER_NAV_ITEMS } from './ownerNav';

export function OwnerBottomNav() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const permissions = readJsonStorage<Permission[]>('permissions', []);

	const items = OWNER_NAV_ITEMS.filter((item) => hasPagePermission(permissions, [], item.path));
	if (!items.length) return null;

	const pathname = location.pathname.toLowerCase();

	return (
		<nav className="sticky bottom-0 z-30 flex items-stretch justify-around rounded-t-2xl border-t border-white/10 bg-owner-sidebar px-1 pt-1.5 pb-[max(0.375rem,env(safe-area-inset-bottom))] shadow-[0_-4px_16px_rgba(0,0,0,0.15)] sm:hidden">
			{items.map((item) => {
				const active = pathname === item.path.toLowerCase() || pathname.startsWith(`${item.path.toLowerCase()}/`);
				return (
					<button
						key={item.path}
						onClick={() => navigate(item.path)}
						aria-current={active ? 'page' : undefined}
						className={cn(
							'mx-0.5 flex flex-1 flex-col items-center gap-0.5 rounded-xl py-1.5 text-[10px] transition-colors',
							active ? 'bg-white/12 font-bold text-white' : 'text-owner-sidebar-foreground/70',
						)}
					>
						<item.Icon size={18} strokeWidth={active ? 2 : 1.5} color={active ? 'var(--owner-accent)' : undefined} />
						<span className="truncate">{t(item.textKey, item.fallback)}</span>
					</button>
				);
			})}
		</nav>
	);
}
